/**
 * @fileoverview Section "Buttons" — toutes les variantes du composant
 * shadcn `<Button>` avec leur usage GNPC recommandé.
 */

import { Button } from '@gnpc/ui';
import { Download, Plus, Loader2, ArrowRight } from 'lucide-react';
import { DsPreview } from '../components/DsPreview.tsx';

export function DsSectionButtons(): JSX.Element {
  return (
    <div className="space-y-8">
      <div className="space-y-3">
        <h3 className="text-sm font-semibold text-quipux-navy-950">Variants</h3>
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          <DsPreview label='variant="default" — CTA principal (Payer, Confirmer)' align="center">
            <Button>Continuer</Button>
          </DsPreview>
          <DsPreview label='variant="secondary" — action forte alternative' align="center">
            <Button variant="secondary">Voir le détail</Button>
          </DsPreview>
          <DsPreview label='variant="outline" — action secondaire neutre' align="center">
            <Button variant="outline">Annuler</Button>
          </DsPreview>
          <DsPreview label='variant="ghost" — action tertiaire dans liste' align="center">
            <Button variant="ghost">Ignorer</Button>
          </DsPreview>
          <DsPreview label='variant="link" — inline dans du texte' align="center">
            <Button variant="link">En savoir plus</Button>
          </DsPreview>
          <DsPreview label='variant="destructive" — révoquer, supprimer' align="center">
            <Button variant="destructive">Révoquer la session</Button>
          </DsPreview>
        </div>
      </div>

      <div className="space-y-3">
        <h3 className="text-sm font-semibold text-quipux-navy-950">Tailles</h3>
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          <DsPreview label='size="xs"' align="center">
            <Button size="xs">Action</Button>
          </DsPreview>
          <DsPreview label='size="sm"' align="center">
            <Button size="sm">Action</Button>
          </DsPreview>
          <DsPreview label='size="default"' align="center">
            <Button>Action</Button>
          </DsPreview>
          <DsPreview label='size="lg"' align="center">
            <Button size="lg">Action</Button>
          </DsPreview>
        </div>
      </div>

      <div className="space-y-3">
        <h3 className="text-sm font-semibold text-quipux-navy-950">Avec icône</h3>
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          <DsPreview label="Icône + label" align="center">
            <Button>
              <Download />
              Télécharger
            </Button>
          </DsPreview>
          <DsPreview label="Label + icône" align="center">
            <Button variant="outline">
              Suivant
              <ArrowRight />
            </Button>
          </DsPreview>
          <DsPreview label='size="icon" — bouton icône pur' align="center">
            <Button size="icon" aria-label="Ajouter">
              <Plus />
            </Button>
          </DsPreview>
          <DsPreview label="Chargement (spinner)" align="center">
            <Button disabled>
              <Loader2 className="animate-spin" />
              Traitement…
            </Button>
          </DsPreview>
        </div>
      </div>

      <div className="space-y-3">
        <h3 className="text-sm font-semibold text-quipux-navy-950">États</h3>
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          <DsPreview label="hover — passe la souris" align="center">
            <Button>Continuer</Button>
          </DsPreview>
          <DsPreview label="focus-visible — Tab clavier" align="center">
            <Button autoFocus>Focus au clavier</Button>
          </DsPreview>
          <DsPreview label="disabled — non cliquable" align="center">
            <Button disabled>Indisponible</Button>
          </DsPreview>
        </div>
      </div>
    </div>
  );
}
